import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import {
  exportSummaryInvoicesPath,
  exportComputereaseXmlInvoicesPath,
  downloadInvoicesInvoicesPath,
  exportDetailInvoicesPath,
  exportSageInvoicesPath
} from 'routes';
import OverflowActionsMenu from '@components/OverflowActionsMenu';
import MarkAsPaid from './MarkAsPaid';
import PublishToCustomerPortal from './PublishToCustomerPortal';
import ExportButton from './ExportButton';

const namespace = 'features.invoices.index.mass_actions';

function MassActions({
  state,
  onSelectAll,
  queryParams,
  onDataChanged,
  hasShowAllInvoicesInCustomerPortal,
  hideExport,
  hasSageIntegration,
  hasComputereaseIntegration
}) {
  const { data: invoices, selectAll, totalCount } = state;
  const selectedInvoices = invoices.filter((invoice) => invoice.selected);
  const disabled = selectedInvoices.length === 0;
  const invoicesCount = selectAll ? totalCount : selectedInvoices.length;
  const invoiceIds = !selectAll && selectedInvoices.map((invoice) => invoice.id).join();

  return (
    <div className="qmb-actions">
      {!disabled && (
        <div className="actions__group--selection">
          <button type="button" className="actions__selection">
            <span className="actions__count">{invoicesCount}</span>
          </button>
          {!selectAll && (
            <div className="actions__entire">
              <button type="button" tabIndex="0" className="qmb-control--sm" onClick={onSelectAll}>
                {translate('selected_global_counter', { namespace, count: totalCount })}
              </button>
            </div>
          )}
        </div>
      )}

      <OverflowActionsMenu className="actions__group" disabled={disabled}>
        <MarkAsPaid
          invoiceIds={invoiceIds}
          invoicesCount={invoicesCount}
          disabled={disabled}
          queryParams={queryParams}
        />

        {!hideExport && hasSageIntegration && (
          <ExportButton
            invoiceIds={invoiceIds}
            disabled={disabled}
            queryParams={queryParams}
            urlPath={exportSageInvoicesPath()}
            translationKey="export_sage_csv"
          />
        )}

        {!hideExport && (
          <ExportButton
            invoiceIds={invoiceIds}
            disabled={disabled}
            queryParams={queryParams}
            urlPath={exportDetailInvoicesPath()}
            translationKey="export_csv_detail"
          />
        )}

        {!hideExport && (
          <ExportButton
            invoiceIds={invoiceIds}
            disabled={disabled}
            queryParams={queryParams}
            urlPath={exportSummaryInvoicesPath()}
            translationKey="export_summary_csv"
          />
        )}

        {!hideExport && hasComputereaseIntegration && (
          <ExportButton
            invoiceIds={invoiceIds}
            disabled={disabled}
            queryParams={queryParams}
            urlPath={exportComputereaseXmlInvoicesPath()}
            translationKey="export_computerease_xml"
          />
        )}

        <ExportButton
          invoiceIds={invoiceIds}
          disabled={disabled}
          queryParams={queryParams}
          urlPath={downloadInvoicesInvoicesPath()}
          translationKey="download_invoices"
          iconClass="fa-download"
        />

        {!hasShowAllInvoicesInCustomerPortal && (
          <PublishToCustomerPortal
            invoiceIds={invoiceIds}
            invoicesCount={invoicesCount}
            disabled={disabled}
            queryParams={queryParams}
            onSuccess={onDataChanged}
          />
        )}
      </OverflowActionsMenu>
    </div>
  );
}

MassActions.propTypes = {
  state: PropTypes.object.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
  onDataChanged: PropTypes.func.isRequired,
  hasShowAllInvoicesInCustomerPortal: PropTypes.bool,
  hideExport: PropTypes.bool,
  hasSageIntegration: PropTypes.bool,
  hasComputereaseIntegration: PropTypes.bool
};

MassActions.defaultProps = {
  hasShowAllInvoicesInCustomerPortal: false,
  hideExport: false,
  hasSageIntegration: false,
  hasComputereaseIntegration: false
};

export default MassActions;
